export function isObjectIn(element: HTMLElement, classes: string[]) {
  if (
    classes.reduce(
      (check, currentClass) =>
        check || element.classList.contains(currentClass),
      false
    )
  ) {
    return true;
  } else if (element.parentElement) {
    return isObjectIn(element.parentElement, classes);
  } else {
    return false;
  }
}

export const SLIDE_TYPES_SUPPORTING_OVERLAY = ['imageSlide'];
